import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { handleSetReturnTo } from "../Func/Storage";
import useClientAuthSession from "../../Hooks/useClientAuthSession";
import {
  login,
  signup,
  accuracy,
  rePass,
  changePass,
  manualdownload,
} from "../../Api/SubUrl";

export default function ClientProtectedRoute({ children }) {
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search || ""}${location.hash || ""}`;

  const isAllowedWhenGuest = useMemo(() => {
    const p = location?.pathname || "/";
    return (
      p === login ||
      p === signup ||
      p === accuracy ||
      p === rePass ||
      p === changePass ||
      p === manualdownload
    );
  }, [location?.pathname]);

  const { isAuthenticated, isPending } = useClientAuthSession();

  if (!isPending && !isAuthenticated && !isAllowedWhenGuest) {
    handleSetReturnTo(returnTo);
    return (
      <Navigate
        to={login}
        replace
        state={{
          returnTo,
        }}
      />
    );
  }

  return children;
}

